import React, { FunctionComponent } from 'react'
import styled, { useTheme } from 'styled-components/native'

import { getSubscriptionPropConfig } from 'features/navigation/navigators/SubscriptionStackNavigator/getSubscriptionPropConfig'
import { AccessibleUnorderedList } from 'ui/components/accessibility/AccessibleUnorderedList'
import { HeroButtonList } from 'ui/components/buttons/HeroButtonList'
import { PageWithHeader } from 'ui/pages/PageWithHeader'
import { NoPhone } from 'ui/svg/icons/NoPhone'
import { PhonePending as InitialPhonePending } from 'ui/svg/icons/PhonePending'
import { Smartphone } from 'ui/svg/icons/Smartphone'
import { Typo } from 'ui/theme'
import { getHeadingAttrs } from 'ui/theme/typographyAttrs/getHeadingAttrs'

export const SelectPhoneStatus: FunctionComponent = () => {
  return (
    <PageWithHeader
      shouldLimitWidth
      title="Identification"
      scrollChildren={<SelectPhoneStatusContent />}
    />
  )
}

const SelectPhoneStatusContent: FunctionComponent = () => {
  const { designSystem } = useTheme()

  const buttonList = [
    <HeroButtonList
      Title={<Typo.Body>J’ai un smartphone à proximité</Typo.Body>}
      Icon={<Smartphone color={designSystem.color.icon.brandPrimary} />}
      navigateTo={getSubscriptionPropConfig('SelectIDStatus')}
      key={1}
    />,
    <HeroButtonList
      Title={<Typo.Body>Je n’ai pas de smartphone à proximité</Typo.Body>}
      Icon={<NoPhone color={designSystem.color.icon.brandPrimary} />}
      navigateTo={getSubscriptionPropConfig('DMSIntroduction', { isForeignDMSInformation: false })}
      key={2}
    />,
  ]

  return (
    <Container>
      <PhonePending />
      <StyledView>
        <StyledTitle4>Vérifie ton identité avec un smartphone</StyledTitle4>
        <StyledBody>
          Gagne du temps en vérifiant ton identité sur un smartphone&nbsp;! Tu peux aussi passer par
          le site demarche.numerique.gouv.fr mais le traitement sera plus long.
        </StyledBody>
      </StyledView>
      <AccessibleUnorderedList items={buttonList} Separator={<Separator />} withPadding />
    </Container>
  )
}

const Separator = styled.View(({ theme }) => ({
  height: theme.designSystem.size.spacing.xl,
}))

const StyledView = styled.View(({ theme }) => ({
  marginTop: theme.designSystem.size.spacing.l,
  marginBottom: theme.designSystem.size.spacing.xxl,
  gap: theme.designSystem.size.spacing.l,
}))
const Container = styled.View(({ theme }) => ({
  height: '100%',
  alignItems: 'center',
  marginHorizontal: theme.designSystem.size.spacing.xs,
  marginVertical: theme.designSystem.size.spacing.xxl,
}))

const PhonePending = styled(InitialPhonePending).attrs(({ theme }) => ({
  color: theme.designSystem.color.icon.brandPrimary,
  size: theme.illustrations.sizes.fullPage,
}))``

const StyledTitle4 = styled(Typo.Title4).attrs(getHeadingAttrs(2))({
  textAlign: 'center',
})
const StyledBody = styled(Typo.Body)({
  textAlign: 'center',
})
